import {ulid} from "ulidx";
import ClientModule from "@/helpers/Modules/Single/ClientModule";
import VehicleModule from "@/helpers/Modules/Single/VehicleModule";
import PolicyModule from "@/helpers/Modules/Single/PolicyModule";
import ObjectModule from "@/helpers/Modules/Single/ObjectModule";
import DictionaryModule from "@/helpers/Modules/Single/DictionaryModule";
import ValidatorModule from "@/helpers/Modules/Single/ValidatorModule";
import permissions from "@/helpers/permissions";

export default class FiModule {
    static Modal = class {
        static infoBlock(val, clientType) {
            const data = {
                1: ['politician', 'entrepreneur', 'bank'], //Страхователь
                2: ['politician', 'entrepreneur'],         //Застрахованный
                3: ['politician', 'entrepreneur'],         //Выгодоприобретатель
            }
            return data[clientType].includes(val)
        }
        static infoCard(val) {
            const data = ['iin', 'person', 'resident']
            return data.includes(val)
        }
        static isOgpo() {
            return false
        }
    }

    static ProgramCondition = class {
        static infoBlock(val) {
            const data = ['av', 'md', 'franchise', 'insuredSum']
            return data.includes(val)
        }
        static infoAgencyReward(role = 3) {
            let av = {
                disabled: !permissions.all().includes(role),
                type: 'input',
                max: 55.56,
                min: 0,
                default: 0,
                dict: {}
            }
            let md = {
                disabled: !permissions.all().includes(role),
                type: 'input',
                max: 55.56,
                min: 0,
                default: 0,
                dict: {}
            }
            let main = {
                max: 55.56,
                min: 0
            }
            return {
                main,
                av,
                md
            }
        }
        static infoInsuredSum(isPerson) {
            return {
                currency: ' ₸',
                max: isPerson ? 500000000 : 2000000000
            }
        }
        static infoFranchises(role = 3) {
            return {
                disabled: !permissions.all().includes(role),
                default: 1,
                dict: {
                    1 :'1 %',
                    2 :'2 %',
                    3 :'3 %',
                    5 :'5 %',
                    7 :'7 %',
                    10:'10 %'
                }
            }
        }
    }

    static Policy = class extends PolicyModule {
        static empty(today = false, product) {
            return {
                ip:       null,
                apc:      null,
                insureds: [],
                insurer:  null,
                product:  product,
                vehicle:  [],
                number:   ulid(),
                treaty: {
                    date: today ?? '',
                    term: 12
                },
                calculationDate: null,
                insuredsShow:    true,
                vehicleShow:     true,
                isDrive:         false,
                premium:         null,
                hasPaid:         false,
                hasCalc:         false,
                hasSave:         false,
                clientAddedList: [],
                carAddedList:    [],
                residentRules: {
                    insurer: null,
                    insured: [],
                    vehicle: [],
                },
                residentRulesError: {
                    rule: null,
                    text: null,
                    key:  null
                },
                podftSuccess: true,
                product_type: null
            }
        }
    }

    static Client = class extends ClientModule {
        static empty() {
            return {
                client: {
                    activity_kind_id:    '',
                    accountant:          '',
                    patronymic:          '',
                    birthday:            '',
                    surname:             '',
                    email:               '',
                    name:                '',
                    iin:                 '',
                    economics_sector_id: 10,
                    id:                  null,
                    sex:                 1,
                    phone:               '7',
                    politician:          true
                },
                filter: {
                    resident:   true,
                    person  :   true,
                    verify  :   true,
                },
                isBeneficiaryFilter: {
                    resident:   true,
                    person  :   false,
                    verify  :   true,
                },
                main: {
                    phone: '7',
                    iin  : '',
                },
                location: {
                    country_id: 1,
                    address:    '',
                    street:     '',
                    float:      '',
                    home:       '',
                    code:       0
                },
                document: {
                    verified_at: '',
                    type_id:     null,
                    number:      '',
                    issued:      '',
                    issuer:  '',
                    until:   ''
                }
            }
        }
        static documentType(step) {
            const documentTypes = {
                0: {1: 'Удостоверение личности', 4: 'Вид на жительство иностранца', 8: 'Удостоверение лица без гражданства', 11:'Паспорт гражданина РК', 12:'Иностранный паспорт'},
                1: {1: 'Удостоверение личности', 4: 'Вид на жительство иностранца', 8: 'Удостоверение лица без гражданства', 11:'Паспорт гражданина РК', 12:'Иностранный паспорт'},
                default: {7: 'Свидетельство о государственной регистрации (перерегистрации) юридического лица'}
            };

            return documentTypes[step] || documentTypes.default;
        }
        static fieldsSettings(step) {
            const data = {
                0: { // Резидент Физ
                    economics_sector_id: { required: false, show: false, disabled:false },
                    activity_kind_id:    { required: false, show: false, disabled:false },
                    patronymic:          { required: false, show: true,  disabled:true  },
                    birthday:            { required: true,  show: true,  disabled:true  },
                    surname:             { required: true,  show: true,  disabled:true  },
                    email:               { required: false, show: true,  disabled:false },
                    phone:               { required: true,  show: true,  disabled:true  },
                    name:                { required: true,  show: true,  disabled:true  },
                    iin:                 { required: true,  show: true,  disabled:true  },
                    sex:                 { required: true,  show: true,  disabled:true  },
                    // Document
                    type_id:             { required: true,  show: true, disabled:true },
                    issued:              { required: true,  show: true, disabled:true },
                    number:              { required: true,  show: true, disabled:true },
                    issuer:              { required: true,  show: true, disabled:true },
                    until:               { required: true,  show: true, disabled:true },
                    // Address
                    country_id:          { required: true, show: false, disabled:true  },
                    address:             { required: true, show: true,  disabled:false }
                },
                1: { // Нерезидент Физ
                    economics_sector_id: { required: false, show: false, disabled:false },
                    activity_kind_id:    { required: false, show: false, disabled:false },
                    patronymic:          { required: false, show: true,  disabled:false },
                    birthday:            { required: true,  show: true,  disabled:true  },
                    surname:             { required: true,  show: true,  disabled:true  },
                    email:               { required: true,  show: true,  disabled:false },
                    phone:               { required: false, show: true,  disabled:false },
                    name:                { required: true,  show: true,  disabled:true  },
                    iin:                 { required: false, show: false, disabled:false },
                    sex:                 { required: true,  show: true,  disabled:true  },
                    // Document
                    type_id:             { required: true,  show: true, disabled:true  },
                    issued:              { required: true,  show: true, disabled:true  },
                    number:              { required: true,  show: true, disabled:true  },
                    issuer:              { required: true,  show: true, disabled:false },
                    until:               { required: false, show: true, disabled:false },
                    // Address
                    country_id:          { required: true,  show: true, disabled:true  },
                    address:             { required: true,  show: true, disabled:false }
                },
                2: { // Резидент Юр
                    economics_sector_id: { required: true,  show: true,  disabled:true  },
                    activity_kind_id:    { required: true,  show: true,  disabled:true  },
                    patronymic:          { required: false, show: false, disabled:false },
                    birthday:            { required: true,  show: true,  disabled:true  },
                    surname:             { required: false, show: false, disabled:false },
                    email:               { required: true,  show: true,  disabled:false },
                    phone:               { required: false, show: false, disabled:false },
                    name:                { required: true,  show: true,  disabled:true  },
                    iin:                 { required: true,  show: true,  disabled:true  },
                    sex:                 { required: false, show: false, disabled:false },
                    // Document
                    type_id:             { required: false, show: false, disabled:false },
                    issued:              { required: false, show: false, disabled:false },
                    number:              { required: false, show: false, disabled:false },
                    issuer:              { required: false, show: false, disabled:false },
                    until:               { required: false, show: false, disabled:false },
                    // Address
                    country_id:          { required: false, show: false, disabled:false },
                    address:             { required: true,  show: true,  disabled:false }
                },
                3: { // Нерезидент Юр
                    economics_sector_id: { required: true,  show: true,  disabled:false },
                    activity_kind_id:    { required: false, show: false, disabled:false },
                    patronymic:          { required: false, show: false, disabled:false },
                    birthday:            { required: true,  show: true,  disabled:false },
                    surname:             { required: false, show: false, disabled:false },
                    email:               { required: true,  show: true,  disabled:false },
                    phone:               { required: false, show: false, disabled:false },
                    name:                { required: true,  show: true,  disabled:false },
                    iin:                 { required: false, show: false, disabled:false },
                    sex:                 { required: false, show: false, disabled:false },
                    // Document
                    type_id:             { required: false, show: false, disabled:false },
                    issued:              { required: false, show: false, disabled:false },
                    number:              { required: false, show: false, disabled:false },
                    issuer:              { required: false, show: false, disabled:false },
                    until:               { required: false, show: false, disabled:false },
                    // Address
                    country_id:          { required: true, show: true, disabled:false },
                    address:             { required: true, show: true, disabled:false }
                },
                4: { // Лидер резидент
                    economics_sector_id: { required: false, show: false, disabled:false },
                    activity_kind_id:    { required: false, show: false, disabled:false },
                    patronymic:          { required: false, show: true,  disabled:false },
                    birthday:            { required: true,  show: true,  disabled:false },
                    surname:             { required: true,  show: true,  disabled:false },
                    email:               { required: false, show: true,  disabled:false },
                    phone:               { required: true,  show: true,  disabled:false },
                    name:                { required: true,  show: true,  disabled:false },
                    iin:                 { required: true,  show: true,  disabled:false },
                    sex:                 { required: true,  show: true,  disabled:false },
                    // Document
                    type_id:             { required: true,  show: true,  disabled:false },
                    issued:              { required: true,  show: true,  disabled:false },
                    number:              { required: true,  show: true,  disabled:false },
                    issuer:              { required: true,  show: true,  disabled:false },
                    until:               { required: false, show: true,  disabled:false },
                    // Address
                    country_id:          { required: false, show: false, disabled:false },
                    address:             { required: false, show: true,  disabled:false }
                },
                5: { // Лидер нерезидент
                    economics_sector_id: { required: false, show: false, disabled:false },
                    activity_kind_id:    { required: false, show: false, disabled:false },
                    patronymic:          { required: false, show: true,  disabled:false },
                    birthday:            { required: true,  show: true,  disabled:false },
                    surname:             { required: true,  show: true,  disabled:false },
                    email:               { required: false, show: true,  disabled:false },
                    phone:               { required: false, show: true,  disabled:false },
                    name:                { required: true,  show: true,  disabled:false },
                    iin:                 { required: false, show: true,  disabled:false },
                    sex:                 { required: true,  show: true,  disabled:false },
                    // Document
                    type_id:             { required: true,  show: true,  disabled:false },
                    issued:              { required: true,  show: true,  disabled:false },
                    number:              { required: true,  show: true,  disabled:false },
                    issuer:              { required: true,  show: true,  disabled:false },
                    until:               { required: false, show: true,  disabled:false },
                    // Address
                    country_id:          { required: true,  show: true,  disabled:false },
                    address:             { required: false, show: true,  disabled:false }
                },
                6: { // Собственник резидент
                    economics_sector_id: { required: false, show: false, disabled:false },
                    activity_kind_id:    { required: false, show: false, disabled:false },
                    patronymic:          { required: false, show: true,  disabled:false },
                    birthday:            { required: true,  show: true,  disabled:false },
                    surname:             { required: true,  show: true,  disabled:false },
                    email:               { required: false, show: true,  disabled:false },
                    phone:               { required: true,  show: true,  disabled:false },
                    name:                { required: true,  show: true,  disabled:false },
                    iin:                 { required: true,  show: true,  disabled:false },
                    sex:                 { required: true,  show: true,  disabled:false },
                    // Document
                    type_id:             { required: true,  show: true,  disabled:false },
                    issued:              { required: true,  show: true,  disabled:false },
                    number:              { required: true,  show: true,  disabled:false },
                    issuer:              { required: true,  show: true,  disabled:false },
                    until:               { required: false, show: true,  disabled:false },
                    // Address
                    country_id:          { required: false, show: false, disabled:false },
                    address:             { required: false, show: true,  disabled:false }
                },
                7: { // Собственник нерезидент
                    economics_sector_id: { required: false, show: false, disabled:false },
                    activity_kind_id:    { required: false, show: false, disabled:false },
                    patronymic:          { required: false, show: true,  disabled:false },
                    birthday:            { required: true,  show: true,  disabled:false },
                    surname:             { required: true,  show: true,  disabled:false },
                    email:               { required: false, show: true,  disabled:false },
                    phone:               { required: false, show: true,  disabled:false },
                    name:                { required: true,  show: true,  disabled:false },
                    iin:                 { required: false, show: true,  disabled:false },
                    sex:                 { required: true,  show: true,  disabled:false },
                    // Document
                    type_id:             { required: true,  show: true,  disabled:false },
                    issued:              { required: true,  show: true,  disabled:false },
                    number:              { required: true,  show: true,  disabled:false },
                    issuer:              { required: true,  show: true,  disabled:false },
                    until:               { required: false, show: true,  disabled:false },
                    // Address
                    country_id:          { required: true,  show: true,  disabled:false },
                    address:             { required: false, show: true,  disabled:false }
                },
                8: { // allow all
                    economics_sector_id: { required: false, show: false, disabled:false },
                    activity_kind_id:    { required: false, show: false, disabled:false },
                    patronymic:          { required: false, show: true,  disabled:false },
                    birthday:            { required: true,  show: true,  disabled:false },
                    surname:             { required: true,  show: true,  disabled:false },
                    email:               { required: false, show: true,  disabled:false },
                    phone:               { required: false, show: true,  disabled:true  },
                    name:                { required: true,  show: true,  disabled:false },
                    iin:                 { required: false, show: true,  disabled:true  },
                    sex:                 { required: true,  show: true,  disabled:false },
                    // Document
                    type_id:             { required: true,  show: true,  disabled:false },
                    issued:              { required: true,  show: true,  disabled:false },
                    number:              { required: true,  show: true,  disabled:false },
                    issuer:              { required: true,  show: true,  disabled:false },
                    until:               { required: false, show: true,  disabled:false },
                    // Address
                    country_id:          { required: true,  show: false, disabled:false },
                    address:             { required: false, show: true,  disabled:false }
                }
            }

            return data[step]
        }
        static bikAndNameByCode(code) {
            const data = {
                '949': { bik:  'ATYNKZKA', name: 'АО "Altyn Bank" (ДБ China Citic Bank Corporation Limited)' },
                '913': { bik:  'BKCHKZKA', name: 'АО ДБ "БАНК КИТАЯ В КАЗАХСТАНЕ"' },
                '914': { bik:  'BRKEKZKA', name: 'АО "Bereke Bank"' },
                '722': { bik:  'CASPKZKA', name: 'АО "KASPI BANK"' },
                '766': { bik:  'CEDUKZKA', name: 'АО "Центральный Депозитарий Ценных Бумаг"' },
                '832': { bik:  'CITIKZKA', name: 'АО "Ситибанк Казахстан"' },
                '907': { bik:  'DVKAKZKA', name: 'АО "Банк Развития Казахстана"' },
                '700': { bik:  'EABRKZKA', name: 'ЕВРАЗИЙСКИЙ БАНК РАЗВИТИЯ' },
                '948': { bik:  'EURIKZKA', name: 'АО "Евразийский Банк"' },
                '009': { bik:  'GCVPKZ2A', name: 'АО "Евразийский Банк"' },
                '972': { bik:  'HCSKKZKA', name: 'АО "Жилищный строительный сберегательный банк "Отбасы банк"' },
                '246': { bik:  'HLALKZKZ', name: 'АО "Исламский Банк "Al Hilal"' },
                '601': { bik:  'HSBKKZKX', name: 'АО "Народный Банк Казахстана"' },
                '930': { bik:  'ICBKKZKX', name: 'АО "Торгово-промышленный Банк Китая в г. Алматы"' },
                '550': { bik:  'INEARUMM', name: 'г.Москва Межгосударственный Банк' },
                '886': { bik:  'INLMKZKA', name: 'АО "Home Credit Bank"' },
                '965': { bik:  'IRTYKZKA', name: 'АО "ForteBank"' },
                '715': { bik:  'KCCJKZKK', name: 'АО "Клиринговый центр KASE"' },
                '856': { bik:  'KCJBKZKX', name: 'АО "Банк ЦентрКредит"' },
                '927': { bik:  'KICEKZKX', name: 'АО "Казахстанская фондовая биржа"' },
                '821': { bik:  'KINCKZKA', name: 'АО "Банк "Bank RBK"' },
                '070': { bik:  'KKMFKZ2A', name: 'РГУ "Комитет казначейства Министерства финансов РК"' },
                '563': { bik:  'KPSTKZKA', name: 'АО "КАЗПОЧТА"' },
                '551': { bik:  'KSNVKZKA', name: 'АО "Банк Фридом Финанс Казахстан"' },
                '885': { bik:  'KZIBKZKA', name: 'АО "ДБ "КАЗАХСТАН-ЗИРААТ ИНТЕРНЕШНЛ БАНК"' },
                '125': { bik:  'NBRKKZKX', name: 'РГУ Национальный Банк Республики Казахстан' },
                '849': { bik:  'NURSKZKX', name: 'АО "Нурбанк"' },
                '435': { bik:  'SHBKKZKA', name: 'АО "Шинхан Банк Казахстан"' },
                '998': { bik:  'TSESKZKA', name: 'АО "First Heartland Jusan Bank"' },
                '432': { bik:  'VTBAKZKZ', name: 'ДО АО Банк ВТБ (Казахстан)' },
                '896': { bik:  'ZAJSKZ22', name: 'АО "Исламский банк "Заман-Банк"' },
            }

            return data[code]
        }
        static modalFilterSettings(step) {
            const data = {
                0: {// default
                    person:         { value: true, disabled: true },
                    resident:       { value: true, disabled: true },
                    verify:         { value: true, disabled: true },
                },
                1: {// Страхователь
                    person:         { value: true, disabled: false },
                    resident:       { value: true, disabled: false },
                    verify:         { value: true, disabled: false },
                },
                2: { // Застрахованный
                    person:         { value: true, disabled: false },
                    resident:       { value: true, disabled: false },
                    verify:         { value: true, disabled: false },
                },
                3: { // Выгодоприобретатель
                    person:         { value: false, disabled: true },
                    resident:       { value: true,  disabled: true },
                    verify:         { value: true,  disabled: true },
                },
                4: { // Владелец
                    person:         { value: true, disabled: true  },
                    resident:       { value: true, disabled: false },
                    verify:         { value: true, disabled: false },
                },
                5: { // Лидер
                    person:         { value: true, disabled: true  },
                    resident:       { value: true, disabled: false },
                    verify:         { value: true, disabled: false },
                }
            }

            return data[step]
        }
        static recalculateDisabledFields(fieldSettings, data) {
            if (!data.document || data.document.number === null || data.document.number === '' || data.document.number === undefined) return fieldSettings
            let formatedData = this.flattenToValues(data)
            const allowedFields = ['issued', 'sex', 'until', 'issuer', 'address', 'email', 'country_id']
            Object.keys(fieldSettings).forEach(key => {
                if (!allowedFields.includes(key)) return
                if (formatedData[key] === null || formatedData[key] === '' || formatedData[key] === undefined) {
                    fieldSettings[key].disabled = false
                }
            })
            return fieldSettings
        }
        static beneficiaryWhitelist() {
            return [
                "950240000112" //АКЦИОНЕРНОЕ ОБЩЕСТВО "ЕВРАЗИЙСКИЙ БАНК"
            ]
        }
    };

    static Vehicle = class extends VehicleModule {
        static empty() {
            return {
                client: {
                    activity_kind_id: '',
                    accountant: '',
                    patronymic: '',
                    birthday: '',
                    surname: '',
                    chief: '',
                    email: '',
                    name: '',
                    iin: '',
                    economics_sector_id: 10,
                    sex: 1,
                    phone: '7',
                    id: null,
                },
                filter: {
                    resident: true,
                    person: true,
                    verify: true,
                },
                main: {
                    phone: '7',
                    iin: '',
                },
                location: {
                    country_id: 1,
                    address: '',
                    street: '',
                    float: '',
                    home: '',
                    code: 0
                },
                document: {
                    verified_at: '',
                    type_id: 1,
                    number: '',
                    issued: '',
                }
            }
        }
        static vehicleDefaultValue(type = 6) {
            return {
                amount: 0,
                cost: 0,
                premium: 0,
                vehicle_id: 0,
                type_id: type,
                vin: null,
                year: null,
                color: null,
                mark: null,
                model: null,
                registration: {
                    number: null,
                    certificate: null,
                    date: null,
                    region_id: null,
                    big_city: null,
                    kato: null,
                },
                engine: {
                    number: null,
                    power: null,
                    volume: null,
                },
                calc: {
                    result: true,
                    premium: 0,
                    message: null,
                    calculationDate: null
                }
            }
        }
        static searchValues(verify) {
            if (verify) return {number:null, certificate:null}
            return {vin:null, certificate:null}
        }
    };

    static Object = class extends ObjectModule {
        static empty() {
            return {
                has_access_system: false, //bool
                has_security:      false, //bool
                loan_number:       null,
                fire_alarm:        null,
                contracts:         null,
                condition:         null,
                region_id:         null,
                ownership:         null,
                activity:          null,
                add_info:          null,
                landlord:          null,
                security:          null,
                address:           null,
                dangers:           null,
                premium:           0,
                amount:            0,
                tenant:            null,
                cost:              0,
                year:              null,
                kind_id:           null, // Тип постройки
                cond_id:           null, // Состояние постройки
                wall_id:           null, // Стены, материал постройки
                selected: {
                    securityMode:   null,
                    ownership:      null,
                    condition:      null,
                    fireAlarm:      null,
                    activity:       null,
                },
            }
        }
    }

    static Dictionary = class extends DictionaryModule {
        static kinds(isImmovable) {
            if (isImmovable) {
                return [
                    'Здания',
                    'Хозяйственные постройки',
                    'Отдельные помещения',
                    'Земельные участки',
                    'Приложение 1'
                ]
            } else {
                return [
                    'Производственное, сельскохозяйственное, инженерно-технологическое оборудование и механизмы',
                    'Офисная мебель и оборудование',
                    'Медицинское оборудование',
                    'Автотранспортные средства (легковые, грузовые, автобусы, спецтехника), на период страхования, стационарно находящиеся по определенному адресу (месту стоянки) без эксплуатации по прямому назначению',
                    'Приложение 1'
                ]
            }
        }
        static activity() {
            return [
                'Офис, торговля',
                'Сфера обслуживания',
                'Производство',
                'Склад',
                'Иное'
            ]
        }
        static ownership() {
            return [
                'На праве собственности',
                'По договору аренды',
                'По договору лизинга',
                'По договору ответственного хранения',
                'Иное'
            ]
        }
        static condition() {
            return [
                'Новое',
                'Неповрежденное, исправное',
                'Поврежденное, неисправное'
            ]
        }
        static fireAlarm() {
            return {
                1:'Да, с выводом на пульт государственной пожарной охраны',
                2:'Да, с выводом на иной пульт с постоянным контролем',
                3:'Нет, не установлена'
            }
        }
        static securityMode() {
            return [
                'Круглосуточно',
                'В рабочее время',
                'В нерабочее время'
            ]
        }
    }

    static Validator = class extends ValidatorModule {
        static bank(data) {
            const { iik, bik, name, kbe } = data;
            const fields = [iik, bik, name, kbe];
            const filledFields = fields.filter(Boolean);
            return filledFields.length === 0 || filledFields.length === fields.length;
        }
        static mod97(string) {
            let checksum = string.slice(0, 2), fragment;
            for (let offset = 2; offset < string.length; offset += 7) {
                fragment = String(checksum) + string.substring(offset, offset + 7);
                checksum = parseInt(fragment, 10) % 97;
            }
            return checksum;
        }
        static formMain(step, form) {
            switch (true) {
                case (step === 0):
                    return form.phone.length === 16 && (form.iin.length === 15)
                case (step === 2):
                    return form.iin.length === 15
                case (step === 1):
                    return  form.document.length > 5
                case (step === 3):
                    return form.name.length > 3
            }
        }
        static objectKeyToKey(data, list) {
            if (data && list) {
                let val = []
                let arr = []
                Object.keys(data).forEach(key => {val.push(`${key}`)});
                list.forEach(item => {arr.push(val.includes(item))})
                return arr.every((elem) => elem >= true)
            }
        }
        static validateClient(data) {
            if (data.client === undefined) return {result: false, message: ''}
            const checks = [
                this.validateFill([data]),
            ]
            if (checks.every((item) => item.result)) {
                return {result: true}
            } else {
                return {result: false, message: checks.find((item) => !item.result).message}
            }
        }
        static validateNameSurname(str) {
            const latinRegex = /[A-Za-z]/;
            const cyrillicRegex = /[А-Яа-яЁёӘәҒғҚқҢңӨөҰұҮүҺһІі]/;
            let firstLang = null;
            for (let i = 0; i < str.length; i++) {
                const char = str[i];
                if (!firstLang && (latinRegex.test(char) || cyrillicRegex.test(char))) {
                    firstLang = latinRegex.test(char) ? "latin" : "cyrillic";
                }
                if (latinRegex.test(char) || cyrillicRegex.test(char)) {
                    if (
                        (firstLang === "latin" && cyrillicRegex.test(char)) ||
                        (firstLang === "cyrillic" && latinRegex.test(char))
                    ) {
                        return {
                            result: false,
                            message: `Недопустимый символ в <b>${str}</b> → "${char}" <br/> Строка должна содержать только ${firstLang === "latin" ? "латиницу" : "кириллицу (включая казахский алфавит)"} <br/> Необходимо сделать распознавание  паспорта еще раз.`
                        };
                    }
                } else if (char === "1" || char === "-" || char === " ") {
                    continue;
                } else {
                    if (/[0-9]/.test(char)) {
                        return {
                            result: false,
                            message: `Недопустимый символ в <b>${str}</b> "${char}" <br/> Разрешена только цифра 1 <br/> Необходимо сделать распознавание  паспорта еще раз.`
                        };
                    } else {
                        return {
                            result: false,
                            message: `Недопустимый символ в <b>${str}</b> "${char}" <br/> Запрещённый символ <br/>  Необходимо сделать распознавание  паспорта еще раз.`
                        };
                    }
                }
            }

            return { result: true, message: '' };
        }
        static validateFill(data) {
            if (!Array.isArray(data)) {
                data = Object.values(data);
            }
            for (let item of data) {
                if (!item || JSON.stringify(item) === '{}') { continue; }
                let filterStep    = FiModule.Client.filterStep(item.filter)
                let fieldSettings   = FiModule.Client.fieldsSettings(filterStep)
                if (!this.validateFields(FiModule.Client.flattenToValues(item), fieldSettings)) {
                    return {result: false, message: 'Пожалуйста, заполните все обязательные поля, чтобы продолжить.'}
                }
                if (!item.filter.resident) {
                    if (!this.validateNameSurname(item.client.name).result || !this.validateNameSurname(item.client.surname).result) {
                        return !this.validateNameSurname(item.client.name).result
                            ? this.validateNameSurname(item.client.name)
                            : this.validateNameSurname(item.client.surname)
                    }
                }
            }
            return {result: true}
        }
        static validateFields(data, settings) {
            if (typeof settings !== 'object' || settings === null || typeof data !== 'object' || data === null) {
                return false;
            }
            return Object.entries(settings).every(([field, properties]) => {
                if (!properties.required) return true
                const value = data[field]
                return value !== null && value !== undefined && value !== ''
            });
        }
        static vehicleValidate(vehicle, limit) {
            let result = {
                result: true,
                message: null
            }
            if (vehicle.cost && (vehicle.cost > limit)) {
                result.result = false
                result.message = '"Действительная стоимость" не должна быть больше '+limit.toLocaleString('ru-RU')+' тг.'
                return result
            }

            if (vehicle.cost < vehicle.amount) {
                result.result = false
                result.message = '"Страховая сумма" не должна быть больше "Действительная стоимость"'
                return result
            }

            if (vehicle.year) {
                const limitYear = new Date().getFullYear() - 10
                if (vehicle.year < limitYear) {
                    result.result = false
                    result.message = '"Год выпуска" не старше 10 лет'
                    return result
                }
            } else {
                this.error = null
            }

            const main = Boolean(vehicle.amount) && Boolean(vehicle.amount) && Boolean(vehicle.type_id)
                && Boolean(vehicle.vin) && Boolean(vehicle.year) && Boolean(vehicle.color) && Boolean(vehicle.mark) && Boolean(vehicle.model)
            const registration = Boolean(vehicle.registration.number) && Boolean(vehicle.registration.certificate)
                && Boolean(vehicle.registration.date) && Boolean(vehicle.registration.region_id)
            const sum = parseInt(vehicle.cost) >= parseInt(vehicle.amount)

            result.result = main && registration && sum
            return result
        }
        static isValidIBANNumber(input) {
            let CODE_LENGTHS = {
                AD: 24, AE: 23, AT: 20, AZ: 28, BA: 20, BE: 16, BG: 22, BH: 22, BR: 29,
                CH: 21, CR: 21, CY: 28, CZ: 24, DE: 22, DK: 18, DO: 28, EE: 20, ES: 24,
                FI: 18, FO: 18, FR: 27, GB: 22, GI: 23, GL: 18, GR: 27, GT: 28, HR: 21,
                HU: 28, IE: 22, IL: 23, IS: 26, IT: 27, JO: 30, KW: 30, KZ: 20, LB: 28,
                LI: 21, LT: 20, LU: 20, LV: 21, MC: 27, MD: 24, ME: 22, MK: 19, MR: 27,
                MT: 31, MU: 30, NL: 18, NO: 15, PK: 24, PL: 28, PS: 29, PT: 25, QA: 29,
                RO: 24, RS: 22, SA: 24, SE: 24, SI: 19, SK: 24, SM: 27, TN: 24, TR: 26,
                AL: 28, BY: 28, CR: 22, EG: 29, GE: 22, IQ: 23, LC: 32, SC: 31, ST: 25,
                SV: 28, TL: 23, UA: 29, VA: 22, VG: 24, XK: 20
            };
            let iban = String(input).toUpperCase().replace(/[^A-Z0-9]/g, ''), // keep only alphanumeric characters
                code = iban.match(/^([A-Z]{2})(\d{2})([A-Z\d]+)$/), // match and capture (1) the country code, (2) the check digits, and (3) the rest
                digits;
            if (!code || iban.length !== CODE_LENGTHS[code[1]]) {
                return false;
            }
            digits = (code[3] + code[1] + code[2]).replace(/[A-Z]/g, function (letter) {
                return letter.charCodeAt(0) - 55;
            });
            return this.mod97(digits) === 1;
        }
        static clientByInfoAndSearchStep(step, clientInfo) {
            const lists = {
                1: ['client', 'filter'],
                2: ['client', 'filter', 'driver', 'document', 'location']
            }

            return this.objectKeyToKey(clientInfo, lists[step])
        }
        static validateBeneficiaryWhiteList(beneficiary) {
            return FiModule.Client.beneficiaryWhitelist().includes(beneficiary)
        }
    }

    test() {
        console.log('test');
    }
}
